import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  ReceiveInboxType,
  SmsAggregator,
  UdhLen,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ThemeColorPipe } from 'src/app/core/utils/theme/theme-color.pipe';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SmsAggregatorImage } from 'src/app/pages/system-management/group-price/shared/directives/sms-aggregator-image.directive';
import { CreateSmsSenderAgentCommand } from '../../../../core/api/models/create-sms-sender-agent-command';
import { UpdateSmsSenderAgentCommand } from '../../../../core/api/models/update-sms-sender-agent-command';
import { SmsSenderAgentsService } from '../../../../core/api/services';
import { RegularExpressions } from '../../../../core/constants/regular-expressions';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { LoadAgentDto } from './../../../../core/api/models/load-agent-dto';
import { SenderAgentType } from './../../../../core/api/models/sender-agent-type';
import { SmsCp } from './../../../../core/api/models/sms-cp';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { DateTimeService } from './../../../../core/services/date-time.service';
import { UtilityService } from './../../../../core/services/utility.service';

@Component({
  selector: 'app-sms-sender-agent-form',
  templateUrl: './sms-sender-agent-form.component.html',
  imports: [BaseFormModule, ThemeColorPipe, SmsAggregatorImage],
})
export class SmsSenderAgentFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<LoadAgentDto> = {};
  model: CreateSmsSenderAgentCommand = {};

  hidePassword: boolean = true;

  endSendTime;
  startSendTime;
  startVal;
  endVal;

  //#region Enums

  get SenderAgentType() {
    return SenderAgentType;
  }
  get SmsAggregator() {
    return SmsAggregator;
  }
  get SmsCp() {
    return SmsCp;
  }
  get ReceiveInboxType() {
    return ReceiveInboxType;
  }
  UdhlenValues: any[];
  finalUdhlenValues: any[];

  //#region smart detail
  urlRightel: string;
  tokenRightel: string;
  urlMtn: string;
  tokenMtn: string;
  urlMci: string;
  tokenMci: string;

  //#endregion

  //#endregion

  //#endregion

  constructor(
    protected currentService: SmsSenderAgentsService,
    private utilityService: UtilityService
  ) {
    super();
    this.UdhlenValues = this.utilityService.enumValuesToArray(UdhLen);
    this.finalUdhlenValues = this.UdhlenValues.map((str) => ({ value: str }));
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.setTimeLimit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
  setTimeLimit() {
    try {
      this.form.valueChanges.subscribe((data) => {
        this.startVal = data.generalInformation.startTime;
        this.endVal = data.generalInformation.endTime;
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initModel() {
    try {
      this.model = {};
      this.model = {
        checkMessageId: false,
        isRecieveActive: false,
        isSendActive: false,
        isSendBulkActive: false,
        isSendSmartActive: false,
      };
      this.startSendTime = '08:00';
      this.endSendTime = '23:59';
      //edit mode
      if (this.formPageConfig.isEditMode) {
        this.formPageConfig.editData = this.formPageConfig.editData;
        this.model = Object.assign({}, this.formPageConfig.editData);
        this.model.socialMediaSmartDetails?.forEach((detail) => {
          if (detail.operator == SmsAggregator.MCI) {
            this.tokenMci = detail.token;
            this.urlMci = detail.url;
          }
          if (detail.operator == SmsAggregator.Irancell) {
            this.tokenMtn = detail.token;
            this.urlMtn = detail.url;
          }
          if (detail.operator == SmsAggregator.Rightel) {
            this.tokenRightel = detail.token;
            this.urlRightel = detail.url;
          }
        });
        this.startSendTime =
          this.formPageConfig.editData.startSendTime.removeTimeSeconds();
        this.endSendTime =
          this.formPageConfig.editData.endSendTime.removeTimeSeconds();

        return;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#region init methods
  initForm() {
    this.form = new FormGroup({
      //اطلاعات عمومی
      generalInformation: new FormGroup({
        name: new FormControl('', Validators.required),
        defaultNumber: new FormControl('', [
          Validators.required,
          Validators.pattern(RegularExpressions.justNumber),
        ]),
        type: new FormControl('', Validators.required),
        smsSenderAgentReference: new FormControl('', Validators.required),
        startTime: new FormControl(
          this.formPageConfig.editData?.startSendTime?.removeTimeSeconds(),
          Validators.required
        ),
        endTime: new FormControl(
          this.formPageConfig.editData?.endSendTime?.removeTimeSeconds(),
          Validators.required
        ),
        isSendActive: new FormControl(''),
        isReceiveActive: new FormControl(''),
        isSendSmartActive: new FormControl(''),
        isSendBulkActive: new FormControl(''),
        isActiveAllTime: new FormControl(''),
        sendBulkIsAutomatic: new FormControl(''),
        checkMessageId: new FormControl(''),
        receiveInboxType: new FormControl('', Validators.required),
      }),
      //اطلاعات دسترسی
      accessInformation: new FormGroup({
        username: new FormControl('', Validators.required),
        password: new FormControl('', [Validators.required]),
        sendLink: new FormControl('', Validators.required),
        receiveLink: new FormControl(''),
        deliveryLink: new FormControl(''),
        domain: new FormControl(''),
        queueLength: new FormControl('', [Validators.required]),
        routeActive: new FormControl(''),
        isP2p: new FormControl(''),
        isSmpp: new FormControl(''),
        isBts: new FormControl(''),
        udhLen: new FormControl('', Validators.required),
      }),
      // جزئیات ارسال هوشمند مدیا
      socialMediaSmartDetails: new FormGroup({
        tokenMci: new FormControl(''),
        urlMci: new FormControl(''),
        tokenMtn: new FormControl(''),
        urlMtn: new FormControl(''),
        tokenRightel: new FormControl(''),
        urlRightel: new FormControl(''),
      }),
    });
  }

  get errorControlGeneralInformation() {
    try {
      let validateGeneralInformation = this.form.controls
        .generalInformation as FormGroup;
      return validateGeneralInformation.controls;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  get errorControlAccessInformation() {
    try {
      let validateAccessInformation = this.form.controls
        .accessInformation as FormGroup;
      return validateAccessInformation.controls;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateSmsSenderAgentCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .smsSenderAgentsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateSmsSenderAgentCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;
    this.currentService
      .smsSenderAgentsUpdatePut({ id: model.id.toString(), body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
    //   this.formPageConfig.isEditMode = false;
  }

  //#endregion

  //#region final methods

  setTime() {
    try {
      let startTime = DateTimeService.combiningTime(this.startSendTime);
      let endTime = DateTimeService.combiningTime(this.endSendTime);
      this.model.startHour = +startTime[0];
      this.model.startMinute = +startTime[1];
      this.model.endHour = +endTime[0];
      this.model.endMinute = +endTime[1];
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  changeTimeValidation(isChecked) {
    try {
      if (isChecked) {
        this.form.get('generalInformation').get('startTime').clearValidators();
        this.form.get('generalInformation').get('endTime').clearValidators();
        this.form
          .get('generalInformation')
          .get('endTime')
          .updateValueAndValidity();
        this.form
          .get('generalInformation')
          .get('startTime')
          .updateValueAndValidity();
      } else {
        this.form
          .get('generalInformation')
          .get('startTime')
          .setValidators(Validators.required);
        this.form
          .get('generalInformation')
          .get('endTime')
          .setValidators(Validators.required);
        this.form
          .get('generalInformation')
          .get('endTime')
          .updateValueAndValidity();
        this.form
          .get('generalInformation')
          .get('startTime')
          .updateValueAndValidity();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  changeIsActiveAll(isChecked) {
    this.changeTimeValidation(isChecked.checked);
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.setTime();
      this.setSocialMediaSmartDetail();
      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  setSocialMediaSmartDetail() {
    if (this.model.smsSenderAgentReference != SmsCp.Mxb) {
      this.model.socialMediaSmartDetails = [];
      return;
    }
    this.model.socialMediaSmartDetails = [
      this.tokenMci || this.urlMci
        ? {
            operator: SmsAggregator.MCI,
            token: this.tokenMci,
            url: this.urlMci,
          }
        : undefined,
      this.tokenMtn || this.urlMtn
        ? {
            operator: SmsAggregator.Irancell,
            token: this.tokenMtn,
            url: this.urlMtn,
          }
        : undefined,
      this.tokenRightel || this.urlRightel
        ? {
            operator: SmsAggregator.Rightel,
            token: this.tokenRightel,
            url: this.urlRightel,
          }
        : undefined,
    ];
    this.model.socialMediaSmartDetails =
      this.model.socialMediaSmartDetails.filter((detail) => {
        return detail != undefined;
      });
  }
}
